import { Navigate, useLocation } from "react-router";
import { SEmbedPage } from "@/pages/SEmbed";
import { SEmbedLoadingState } from "@/pages/SEmbed/SEmbedLoadingState";
import { useSFullApp } from "@/hooks/useSFullApp";

export function AIDashboards() {
  const fullApp = useSFullApp();
  const location = useLocation();

  if (fullApp.isLoading) {
    return (
      <div className="px-4 pt-4 w-full h-full">
        <SEmbedLoadingState />
      </div>
    );
  }

  if (fullApp.enabled)
    return <Navigate to={`/home/dashboards${location.search}${location.hash}`} replace />;
  return <SEmbedPage section="dashboards" />;
}
